import factory from '../requestFactory';
import store from '@/store'

export default (analyzeId) => {
    let params = {
        patient_id: store.getters.patient.id,
        base_encode:true
    }
    return factory()
        .get(`/patient/analyzes/${analyzeId}/document`, {params:params})

};
